// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.audit-schedule-page {
  padding-bottom: 80px;
}

.audit-schedule-breadcrumb .breadcrumb {
  background: transparent;
  padding: 0;
}

.audit-schedule-breadcrumb .breadcrumb-item a {
  color: var(--bs-body-color);
  text-decoration: none;
}

.audit-schedule-breadcrumb .breadcrumb-item.active {
  color: var(--bs-secondary);
}

.audit-schedule-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

/* Company card */
.audit-schedule-info-card {
  background-color: #f0f0f0;
  border: 1px solid #e0e0e0;
}

.audit-schedule-employee-fields-card {
  background-color: #f0f0f0 !important;
  border: 1px solid #e0e0e0;
}

.audit-schedule-employee-fields-card .card-body {
  background-color: #f0f0f0 !important;
}

.audit-schedule-company-card {
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  position: relative;
}

.audit-schedule-company-banner {
  height: 56px;
  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);
}

.audit-schedule-company-card-body {
  padding: 1rem 1.5rem 1.5rem;
  margin-top: -24px;
  position: relative;
  background: var(--bs-body-bg);
}

.audit-schedule-company-avatar {
  width: 56px;
  height: 56px;
  border-radius: 0.5rem;
  background: #e9ecef;
  color: #000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.25rem;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.audit-schedule-company-name {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.25rem 0;
}

.audit-schedule-company-id {
  font-size: 0.875rem;
  color: var(--bs-secondary);
}

/* Company flag – light badges (filled light background + darker text), dot in real color */
.audit-schedule-light-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
  border: 1px solid transparent;
}

.audit-schedule-light-badge::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: currentColor;
  flex-shrink: 0;
}

.audit-schedule-light-badge--priority {
  background-color: #f8d7da;
  color: #b02a37;
  border-color: #f5c2c7;
}

.audit-schedule-light-badge--exclusive {
  background-color: #e2d9f3;
  color: #432874;
  border-color: #c9b8e8;
}

.audit-schedule-light-badge--engaged {
  background-color: #cfe2ff;
  color: #084298;
  border-color: #b6d4fe;
}

.audit-schedule-light-badge--cbqa_malaysia {
  background-color: #ffe5d0;
  color: #9a4d0e;
  border-color: #ffd9b8;
}

.audit-schedule-light-badge--i_marks {
  background-color: #d1e7dd;
  color: #0f5132;
  border-color: #a3cfbb;
}

.audit-schedule-light-badge--grg {
  background-color: #cff4fc;
  color: #055160;
  border-color: #9eeaf9;
}

.audit-schedule-light-badge--egg {
  background-color: #f8d7ea;
  color: #9d2b5a;
  border-color: #f1aec9;
}

.audit-schedule-light-badge--new_client {
  background-color: #d1e7dd;
  color: #0f5132;
  border-color: #a3cfbb;
}

.audit-schedule-light-badge--disqualified {
  background-color: #e2e3e5;
  color: #495057;
  border-color: #c4c8cb;
}

.audit-schedule-light-badge--binary_work_client {
  background-color: #cff4f0;
  color: #0a6b63;
  border-color: #99e2db;
}

.audit-schedule-light-badge--default {
  background-color: var(--bs-secondary-bg);
  color: var(--bs-secondary);
  border-color: var(--bs-border-color);
}

.audit-schedule-company-details-card {
  background-color: #fff !important;
  border: 1px solid #dee2e6;
}

.audit-schedule-company-details-card .card-body {
  background-color: #fff !important;
}

.audit-schedule-company-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem 2rem;
  margin-top: 0;
}

.audit-schedule-detail-label {
  display: block;
  font-size: 0.75rem;
  color: var(--bs-secondary);
  margin-bottom: 0.25rem;
}

.audit-schedule-detail-value {
  font-size: 0.875rem;
}

.audit-schedule-detail-value[href] {
  color: #0d6efd;
  text-decoration: underline;
}

/* Section cards */
.audit-schedule-section-card {
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.audit-schedule-section-card.accordion {
  border: 1px solid var(--bs-border-color);
  background: #ffffff;
}

.audit-schedule-section-card.accordion .accordion-item {
  background: var(--bs-body-bg) !important;
  border-color: var(--bs-border-color);
}

.audit-schedule-section-card.accordion .accordion-button {
  background: var(--bs-body-bg) !important;
  color: var(--bs-body-color);
}

.audit-schedule-section-card.accordion .accordion-button:not(.collapsed) {
  background: var(--bs-body-bg) !important;
  color: var(--bs-body-color);
}

.audit-schedule-section-card.accordion .accordion-body {
  background: var(--bs-body-bg) !important;
}

.audit-schedule-section-card .card-header {
  background: var(--bs-body-bg);
  border-bottom: 1px solid var(--bs-border-color);
  padding: 0.75rem 1rem;
}

.audit-schedule-section-card .card-title {
  font-size: 1rem;
  font-weight: 600;
}

.audit-schedule-surveillance-card {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.audit-schedule-surveillance-card .card-header {
  background: var(--bs-body-bg);
  border-bottom: 1px solid var(--bs-border-color);
  padding: 0.75rem 1rem;
}

.audit-schedule-surveillance-card .card-title {
  font-size: 0.9375rem;
  font-weight: 600;
}

.audit-schedule-employee-card {
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  background: var(--bg-secondary) !important;
}

.audit-schedule-employee-card .card-header.audit-schedule-employee-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e9ecef !important;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1rem;
}

.audit-schedule-employee-card .card-body {
  padding: 1rem;
  background: var(--bs-secondary-bg) !important;
}

/* Uploaded document cards */
.audit-schedule-document-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.audit-schedule-document-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
}

.audit-schedule-document-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  min-width: 40px;
  background: #f0f0f0;
  border-radius: 6px;
  color: #6c757d;
}

.audit-schedule-document-card-info {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
}

.audit-schedule-document-card-name {
  font-size: 0.875rem;
  font-weight: 500;
  color: #0d6efd;
}

.audit-schedule-document-card-size {
  font-size: 0.75rem;
  color: #a0a0a0;
}

.audit-schedule-document-card-actions {
  flex-shrink: 0;
}

.audit-schedule-document-action {
  color: #0d6efd !important;
}

.audit-schedule-document-action:hover {
  color: #0a58ca !important;
}

.audit-schedule-document-action-remove {
  color: #dc3545 !important;
}

.audit-schedule-document-action-remove:hover {
  color: #b02a37 !important;
}

/* Upload zone */
.audit-schedule-upload-zone {
  border: 2px dashed var(--bs-border-color);
  border-radius: 0.5rem;
  padding: 2rem;
  text-align: center;
  background: var(--bs-tertiary-bg);
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s;
}

.audit-schedule-upload-zone:hover {
  border-color: var(--bs-primary);
  background: rgba(var(--bs-primary-rgb), 0.05);
}

.audit-schedule-upload-zone--dragover {
  border-color: var(--bs-primary);
  background: rgba(var(--bs-primary-rgb), 0.1);
}

/* Site Location tab */
.audit-schedule-site-location-card {
  background: #fff;
  border: 1px solid #e0e0e0;
}

.audit-schedule-site-accordion-item {
  border: none;
  border-bottom: 1px solid var(--bs-border-color);
}

.audit-schedule-site-accordion-item:last-child {
  border-bottom: none;
}

.audit-schedule-site-accordion-btn {
  background: transparent !important;
  box-shadow: none !important;
  font-weight: 500;
}

.audit-schedule-site-detail-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.audit-schedule-site-detail-label {
  font-size: 0.875rem;
  color: var(--bs-secondary);
  flex-shrink: 0;
}

.audit-schedule-site-detail-value {
  font-size: 0.875rem;
  text-align: right;
}

.audit-schedule-site-email {
  color: #0d6efd;
  text-decoration: none;
}

.audit-schedule-site-email:hover {
  text-decoration: underline;
}

.audit-schedule-site-person-card {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  background: #f0f0f0;
  border-radius: 6px;
  margin-top: 0.5rem;
}

.audit-schedule-site-person-avatar {
  width: 36px;
  height: 36px;
  min-width: 36px;
  border-radius: 50%;
  background: #0d9488;
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
}

.audit-schedule-site-person-name {
  font-size: 0.875rem;
  font-weight: 500;
  flex-grow: 1;
}

.audit-schedule-site-person-mandays {
  font-size: 0.875rem;
  color: var(--bs-secondary);
}

.audit-schedule-site-person-type {
  font-size: 0.875rem;
  color: var(--bs-secondary);
}

.audit-schedule-transport-title {
  font-weight: 500;
}

.audit-schedule-site-location-submit {
  display: flex;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1rem;
}

.audit-schedule-site-location-submit .btn-teal {
  background: #0d9488;
  color: #fff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 6px;
}

.audit-schedule-site-location-submit .btn-teal:hover {
  background: #0f766e;
  color: #fff;
}

/* Official Trip tab */
.audit-schedule-official-trip-card {
  background: var(--bs-body-bg);
  border: 1px solid var(--bs-border-color);
  border-radius: 0.5rem;
  overflow: hidden;
}

.audit-schedule-official-trip-accordion .accordion-item {
  border: none;
  border-bottom: 1px solid var(--bs-border-color);
}

.audit-schedule-official-trip-accordion .accordion-item:last-child {
  border-bottom: none;
}

.audit-schedule-official-trip-accordion .accordion-button::after {
  display: none;
}

/* Person-level (site.person.name): white accordion header, rounded edges */
.audit-schedule-official-trip-person-section .accordion-button,
.audit-schedule-official-trip-person-btn {
  background: #fff !important;
  box-shadow: none !important;
}

.audit-schedule-official-trip-accordion .accordion-item:first-child .accordion-button {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.audit-schedule-official-trip-accordion .accordion-item:last-child .accordion-button {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.audit-schedule-official-trip-accordion .accordion-item:last-child .accordion-collapse .accordion-body {
  border-bottom-left-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.audit-schedule-official-trip-person-section .accordion-button:not(.collapsed),
.audit-schedule-official-trip-person-btn:not(.collapsed) {
  background: #fff !important;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.audit-schedule-official-trip-person-body {
  padding-top: 0.5rem;
  background: #fff !important;
  border-radius: 0 0 0.5rem 0.5rem;
}

[data-bs-theme="dark"] .audit-schedule-official-trip-person-body {
  background: var(--bs-body-bg) !important;
}

/* Site-level: accordion with same border/shadow style as accommodation card */
.audit-schedule-official-trip-site-section {
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 0.75rem;
  overflow: hidden;
}

.audit-schedule-official-trip-site-section:last-child {
  margin-bottom: 0;
}

.audit-schedule-official-trip-site-accordion .accordion-item {
  border: none;
  border-bottom: none;
}

.audit-schedule-official-trip-site-accordion .accordion-item:last-child {
  border-bottom: none;
}

.audit-schedule-official-trip-site-accordion .accordion-button::after {
  display: none;
}

.audit-schedule-official-trip-site-btn {
  background: transparent !important;
  box-shadow: none !important;
  font-weight: 500;
  border-radius: 0.5rem;
}

.audit-schedule-official-trip-site-btn:not(.collapsed) {
  background: transparent !important;
  border-radius: 0.5rem 0.5rem 0 0;
}

.audit-schedule-official-trip-site-accordion .accordion-body {
  padding: 1rem 1.25rem;
  border-top: 1px solid #dee2e6;
  border-radius: 0 0 0.5rem 0.5rem;
}

[data-bs-theme="dark"] .audit-schedule-official-trip-site-section {
  border-color: var(--bs-border-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

[data-bs-theme="dark"] .audit-schedule-official-trip-site-accordion .accordion-body {
  border-top-color: var(--bs-border-color);
}

[data-bs-theme="dark"] .audit-schedule-official-trip-person-section .accordion-button,
[data-bs-theme="dark"] .audit-schedule-official-trip-person-btn {
  background: var(--bs-body-bg) !important;
}

[data-bs-theme="dark"] .audit-schedule-official-trip-person-section .accordion-button:not(.collapsed),
[data-bs-theme="dark"] .audit-schedule-official-trip-person-btn:not(.collapsed) {
  background: var(--bs-body-bg) !important;
}

.audit-schedule-official-trip-section-btn {
  background: transparent !important;
  box-shadow: none !important;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem 1rem;
}

.audit-schedule-official-trip-section-title {
  font-weight: 600;
  font-size: 1rem;
  flex: 1 1;
  text-align: left;
}

.audit-schedule-official-trip-chevron {
  flex-shrink: 0;
  transition: transform 0.2s ease;
  color: var(--bs-secondary);
}

.audit-schedule-official-trip-section-btn:not(.collapsed) .audit-schedule-official-trip-chevron {
  transform: rotate(180deg);
}

.audit-schedule-official-trip-accordion .accordion-body {
  padding: 1rem 1.5rem;
  background: #f8f9fa;
}

[data-bs-theme="dark"] .audit-schedule-official-trip-accordion .accordion-body {
  background: var(--bs-tertiary-bg);
}

.audit-schedule-official-trip-accommodation-card {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.25rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden; /* keep row negative margins from pushing checkboxes outside the card */
}

[data-bs-theme="dark"] .audit-schedule-official-trip-accommodation-card {
  background: var(--bs-secondary-bg);
  border-color: var(--bs-border-color);
}

.audit-schedule-official-trip-accommodation-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.25rem;
  padding-bottom: 0;
}

.audit-schedule-official-trip-accommodation-heading {
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
}

.audit-schedule-official-trip-accommodation-remove {
  background: none;
  border: none;
  color: #dc3545;
  padding: 0.25rem;
  line-height: 0;
  cursor: pointer;
  border-radius: 4px;
}

.audit-schedule-official-trip-accommodation-remove:hover {
  color: #b02a37;
  background: rgba(220, 53, 69, 0.1);
}

.audit-schedule-official-trip-fields {
  margin-bottom: 0;
  /* Neutralize Bootstrap row negative margins so content stays inside the card */
  margin-left: 0;
  margin-right: 0;
}

.audit-schedule-official-trip-fields > [class*="col-"] {
  margin-bottom: 0;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.audit-schedule-official-trip-fields > [class*="col-"]:first-child {
  padding-left: 0;
}

.audit-schedule-official-trip-fields > [class*="col-"]:last-child {
  padding-right: 0;
}

.audit-schedule-official-trip-toggle {
  padding: 0.5rem 0;
  margin-bottom: 0;
}

.audit-schedule-official-trip-accommodation-card .audit-schedule-official-trip-toggle {
  margin-top: 0.25rem;
}

/* Keep the switch and label aligned; prevent checkbox from being pushed to edge */
.audit-schedule-official-trip-accommodation-card .audit-schedule-official-trip-toggle.form-check {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  padding-left: 0;
}

.audit-schedule-official-trip-toggle .form-check-input {
  cursor: pointer;
  flex-shrink: 0;
  margin-left: 0;
  margin-top: 0.2rem;
}

/* Prevent Bootstrap form-switch from positioning the input at the container edge */
.audit-schedule-official-trip-accommodation-card .form-check.form-switch .form-check-input {
  position: relative;
  left: 0;
}

.audit-schedule-official-trip-toggle .form-check-label {
  cursor: pointer;
  font-size: 0.875rem;
}

.audit-schedule-official-trip-contacts {
  padding: 0.75rem 0;
  border-top: 1px solid var(--bs-border-color);
}

.audit-schedule-official-trip-contacts-title {
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
}

.audit-schedule-official-trip-contact-row {
  padding: 0.5rem 0;
  border-bottom: 1px solid var(--bs-tertiary-bg);
}

.audit-schedule-official-trip-contact-row:last-of-type {
  border-bottom: none;
}

.audit-schedule-official-trip-add-contact {
  margin-top: 0.5rem;
}

.audit-schedule-official-trip-docs-label {
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0 0 0.5rem 0;
}

.audit-schedule-official-trip-accommodation-card .audit-schedule-official-trip-docs-label {
  margin-top: 0.75rem;
}

.audit-schedule-official-trip-upload-zone {
  padding: 1.5rem 1rem !important;
  border: 2px dashed #dee2e6;
  background: #f8f9fa;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.audit-schedule-official-trip-upload-zone:hover {
  border-color: #adb5bd;
  background: #f1f3f5;
}

.audit-schedule-official-trip-upload-zone .small {
  display: block;
}

.audit-schedule-official-trip-doc-list {
  list-style: none;
  padding: 0;
  margin: 0 0 0.5rem 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.audit-schedule-official-trip-doc-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.35rem 0;
  font-size: 0.875rem;
}

.audit-schedule-official-trip-doc-item span {
  color: #0d6efd;
}

.audit-schedule-official-trip-document-list {
  margin-top: 0.25rem;
}

.audit-schedule-official-trip-document-list .audit-schedule-document-card {
  background: #fff;
  border-color: #e9ecef;
}

[data-bs-theme="dark"] .audit-schedule-official-trip-document-list .audit-schedule-document-card {
  background: var(--bs-body-bg);
  border-color: var(--bs-border-color);
}

.audit-schedule-official-trip-add-accommodation {
  margin-top: 0.75rem;
}

/* Required field asterisk (Official Trip) */
.audit-schedule-label-required::after,
.audit-schedule-official-trip-accommodation-card .row.g-3 > .col-12:first-child .form-label::after {
  content: ' *';
  color: #dc3545;
}

.audit-schedule-official-trip-upload-icon {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.audit-schedule-official-trip-upload-text {
  font-size: 0.875rem;
  color: var(--bs-body-color);
  margin: 0;
}

.audit-schedule-official-trip-upload-formats {
  font-size: 0.8125rem;
}

/* Footer */
.audit-schedule-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: var(--bs-body-bg);
  border-top: 1px solid var(--bs-border-color);
  padding: 1rem 1.5rem;
  z-index: 100;
}

@media (min-width: 768px) {
  .audit-schedule-company-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditSchedule/AuditSchedule.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,2FAA2F;AAC3F;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;EAC7B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,yCAAyC;EACzC,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,2EAA2E;AAC3E;;EAEE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8EAA8E;AAC9E;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB,EAAE,uEAAuE;AAC3F;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,+EAA+E;EAC/E,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA,mFAAmF;AACnF;EACE,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,4CAA4C;EAC5C,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":[".audit-schedule-page {\n  padding-bottom: 80px;\n}\n\n.audit-schedule-breadcrumb .breadcrumb {\n  background: transparent;\n  padding: 0;\n}\n\n.audit-schedule-breadcrumb .breadcrumb-item a {\n  color: var(--bs-body-color);\n  text-decoration: none;\n}\n\n.audit-schedule-breadcrumb .breadcrumb-item.active {\n  color: var(--bs-secondary);\n}\n\n.audit-schedule-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n/* Company card */\n.audit-schedule-info-card {\n  background-color: #f0f0f0;\n  border: 1px solid #e0e0e0;\n}\n\n.audit-schedule-employee-fields-card {\n  background-color: #f0f0f0 !important;\n  border: 1px solid #e0e0e0;\n}\n\n.audit-schedule-employee-fields-card .card-body {\n  background-color: #f0f0f0 !important;\n}\n\n.audit-schedule-company-card {\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  position: relative;\n}\n\n.audit-schedule-company-banner {\n  height: 56px;\n  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);\n}\n\n.audit-schedule-company-card-body {\n  padding: 1rem 1.5rem 1.5rem;\n  margin-top: -24px;\n  position: relative;\n  background: var(--bs-body-bg);\n}\n\n.audit-schedule-company-avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: 0.5rem;\n  background: #e9ecef;\n  color: #000;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 1.25rem;\n  flex-shrink: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.audit-schedule-company-name {\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 0.25rem 0;\n}\n\n.audit-schedule-company-id {\n  font-size: 0.875rem;\n  color: var(--bs-secondary);\n}\n\n/* Company flag – light badges (filled light background + darker text), dot in real color */\n.audit-schedule-light-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  padding: 0.25rem 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border: 1px solid transparent;\n}\n\n.audit-schedule-light-badge::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background-color: currentColor;\n  flex-shrink: 0;\n}\n\n.audit-schedule-light-badge--priority {\n  background-color: #f8d7da;\n  color: #b02a37;\n  border-color: #f5c2c7;\n}\n\n.audit-schedule-light-badge--exclusive {\n  background-color: #e2d9f3;\n  color: #432874;\n  border-color: #c9b8e8;\n}\n\n.audit-schedule-light-badge--engaged {\n  background-color: #cfe2ff;\n  color: #084298;\n  border-color: #b6d4fe;\n}\n\n.audit-schedule-light-badge--cbqa_malaysia {\n  background-color: #ffe5d0;\n  color: #9a4d0e;\n  border-color: #ffd9b8;\n}\n\n.audit-schedule-light-badge--i_marks {\n  background-color: #d1e7dd;\n  color: #0f5132;\n  border-color: #a3cfbb;\n}\n\n.audit-schedule-light-badge--grg {\n  background-color: #cff4fc;\n  color: #055160;\n  border-color: #9eeaf9;\n}\n\n.audit-schedule-light-badge--egg {\n  background-color: #f8d7ea;\n  color: #9d2b5a;\n  border-color: #f1aec9;\n}\n\n.audit-schedule-light-badge--new_client {\n  background-color: #d1e7dd;\n  color: #0f5132;\n  border-color: #a3cfbb;\n}\n\n.audit-schedule-light-badge--disqualified {\n  background-color: #e2e3e5;\n  color: #495057;\n  border-color: #c4c8cb;\n}\n\n.audit-schedule-light-badge--binary_work_client {\n  background-color: #cff4f0;\n  color: #0a6b63;\n  border-color: #99e2db;\n}\n\n.audit-schedule-light-badge--default {\n  background-color: var(--bs-secondary-bg);\n  color: var(--bs-secondary);\n  border-color: var(--bs-border-color);\n}\n\n.audit-schedule-company-details-card {\n  background-color: #fff !important;\n  border: 1px solid #dee2e6;\n}\n\n.audit-schedule-company-details-card .card-body {\n  background-color: #fff !important;\n}\n\n.audit-schedule-company-grid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.75rem 2rem;\n  margin-top: 0;\n}\n\n.audit-schedule-detail-label {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--bs-secondary);\n  margin-bottom: 0.25rem;\n}\n\n.audit-schedule-detail-value {\n  font-size: 0.875rem;\n}\n\n.audit-schedule-detail-value[href] {\n  color: #0d6efd;\n  text-decoration: underline;\n}\n\n/* Section cards */\n.audit-schedule-section-card {\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.audit-schedule-section-card.accordion {\n  border: 1px solid var(--bs-border-color);\n  background: #ffffff;\n}\n\n.audit-schedule-section-card.accordion .accordion-item {\n  background: var(--bs-body-bg) !important;\n  border-color: var(--bs-border-color);\n}\n\n.audit-schedule-section-card.accordion .accordion-button {\n  background: var(--bs-body-bg) !important;\n  color: var(--bs-body-color);\n}\n\n.audit-schedule-section-card.accordion .accordion-button:not(.collapsed) {\n  background: var(--bs-body-bg) !important;\n  color: var(--bs-body-color);\n}\n\n.audit-schedule-section-card.accordion .accordion-body {\n  background: var(--bs-body-bg) !important;\n}\n\n.audit-schedule-section-card .card-header {\n  background: var(--bs-body-bg);\n  border-bottom: 1px solid var(--bs-border-color);\n  padding: 0.75rem 1rem;\n}\n\n.audit-schedule-section-card .card-title {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.audit-schedule-surveillance-card {\n  border: 1px solid var(--bs-border-color);\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.audit-schedule-surveillance-card .card-header {\n  background: var(--bs-body-bg);\n  border-bottom: 1px solid var(--bs-border-color);\n  padding: 0.75rem 1rem;\n}\n\n.audit-schedule-surveillance-card .card-title {\n  font-size: 0.9375rem;\n  font-weight: 600;\n}\n\n.audit-schedule-employee-card {\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  background: var(--bg-secondary) !important;\n}\n\n.audit-schedule-employee-card .card-header.audit-schedule-employee-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #e9ecef !important;\n  border-bottom: 1px solid #dee2e6;\n  padding: 0.75rem 1rem;\n}\n\n.audit-schedule-employee-card .card-body {\n  padding: 1rem;\n  background: var(--bs-secondary-bg) !important;\n}\n\n/* Uploaded document cards */\n.audit-schedule-document-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.audit-schedule-document-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: #fff;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n}\n\n.audit-schedule-document-card-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  background: #f0f0f0;\n  border-radius: 6px;\n  color: #6c757d;\n}\n\n.audit-schedule-document-card-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n}\n\n.audit-schedule-document-card-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #0d6efd;\n}\n\n.audit-schedule-document-card-size {\n  font-size: 0.75rem;\n  color: #a0a0a0;\n}\n\n.audit-schedule-document-card-actions {\n  flex-shrink: 0;\n}\n\n.audit-schedule-document-action {\n  color: #0d6efd !important;\n}\n\n.audit-schedule-document-action:hover {\n  color: #0a58ca !important;\n}\n\n.audit-schedule-document-action-remove {\n  color: #dc3545 !important;\n}\n\n.audit-schedule-document-action-remove:hover {\n  color: #b02a37 !important;\n}\n\n/* Upload zone */\n.audit-schedule-upload-zone {\n  border: 2px dashed var(--bs-border-color);\n  border-radius: 0.5rem;\n  padding: 2rem;\n  text-align: center;\n  background: var(--bs-tertiary-bg);\n  cursor: pointer;\n  transition: border-color 0.15s, background-color 0.15s;\n}\n\n.audit-schedule-upload-zone:hover {\n  border-color: var(--bs-primary);\n  background: rgba(var(--bs-primary-rgb), 0.05);\n}\n\n.audit-schedule-upload-zone--dragover {\n  border-color: var(--bs-primary);\n  background: rgba(var(--bs-primary-rgb), 0.1);\n}\n\n/* Site Location tab */\n.audit-schedule-site-location-card {\n  background: #fff;\n  border: 1px solid #e0e0e0;\n}\n\n.audit-schedule-site-accordion-item {\n  border: none;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.audit-schedule-site-accordion-item:last-child {\n  border-bottom: none;\n}\n\n.audit-schedule-site-accordion-btn {\n  background: transparent !important;\n  box-shadow: none !important;\n  font-weight: 500;\n}\n\n.audit-schedule-site-detail-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.audit-schedule-site-detail-label {\n  font-size: 0.875rem;\n  color: var(--bs-secondary);\n  flex-shrink: 0;\n}\n\n.audit-schedule-site-detail-value {\n  font-size: 0.875rem;\n  text-align: right;\n}\n\n.audit-schedule-site-email {\n  color: #0d6efd;\n  text-decoration: none;\n}\n\n.audit-schedule-site-email:hover {\n  text-decoration: underline;\n}\n\n.audit-schedule-site-person-card {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.75rem 1rem;\n  background: #f0f0f0;\n  border-radius: 6px;\n  margin-top: 0.5rem;\n}\n\n.audit-schedule-site-person-avatar {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  border-radius: 50%;\n  background: #0d9488;\n  color: #fff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.audit-schedule-site-person-name {\n  font-size: 0.875rem;\n  font-weight: 500;\n  flex-grow: 1;\n}\n\n.audit-schedule-site-person-mandays {\n  font-size: 0.875rem;\n  color: var(--bs-secondary);\n}\n\n.audit-schedule-site-person-type {\n  font-size: 0.875rem;\n  color: var(--bs-secondary);\n}\n\n.audit-schedule-transport-title {\n  font-weight: 500;\n}\n\n.audit-schedule-site-location-submit {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n}\n\n.audit-schedule-site-location-submit .btn-teal {\n  background: #0d9488;\n  color: #fff;\n  border: none;\n  padding: 0.5rem 1.5rem;\n  border-radius: 6px;\n}\n\n.audit-schedule-site-location-submit .btn-teal:hover {\n  background: #0f766e;\n  color: #fff;\n}\n\n/* Official Trip tab */\n.audit-schedule-official-trip-card {\n  background: var(--bs-body-bg);\n  border: 1px solid var(--bs-border-color);\n  border-radius: 0.5rem;\n  overflow: hidden;\n}\n\n.audit-schedule-official-trip-accordion .accordion-item {\n  border: none;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.audit-schedule-official-trip-accordion .accordion-item:last-child {\n  border-bottom: none;\n}\n\n.audit-schedule-official-trip-accordion .accordion-button::after {\n  display: none;\n}\n\n/* Person-level (site.person.name): white accordion header, rounded edges */\n.audit-schedule-official-trip-person-section .accordion-button,\n.audit-schedule-official-trip-person-btn {\n  background: #fff !important;\n  box-shadow: none !important;\n}\n\n.audit-schedule-official-trip-accordion .accordion-item:first-child .accordion-button {\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n\n.audit-schedule-official-trip-accordion .accordion-item:last-child .accordion-button {\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.audit-schedule-official-trip-accordion .accordion-item:last-child .accordion-collapse .accordion-body {\n  border-bottom-left-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.audit-schedule-official-trip-person-section .accordion-button:not(.collapsed),\n.audit-schedule-official-trip-person-btn:not(.collapsed) {\n  background: #fff !important;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.audit-schedule-official-trip-person-body {\n  padding-top: 0.5rem;\n  background: #fff !important;\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-person-body {\n  background: var(--bs-body-bg) !important;\n}\n\n/* Site-level: accordion with same border/shadow style as accommodation card */\n.audit-schedule-official-trip-site-section {\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  margin-bottom: 0.75rem;\n  overflow: hidden;\n}\n\n.audit-schedule-official-trip-site-section:last-child {\n  margin-bottom: 0;\n}\n\n.audit-schedule-official-trip-site-accordion .accordion-item {\n  border: none;\n  border-bottom: none;\n}\n\n.audit-schedule-official-trip-site-accordion .accordion-item:last-child {\n  border-bottom: none;\n}\n\n.audit-schedule-official-trip-site-accordion .accordion-button::after {\n  display: none;\n}\n\n.audit-schedule-official-trip-site-btn {\n  background: transparent !important;\n  box-shadow: none !important;\n  font-weight: 500;\n  border-radius: 0.5rem;\n}\n\n.audit-schedule-official-trip-site-btn:not(.collapsed) {\n  background: transparent !important;\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n\n.audit-schedule-official-trip-site-accordion .accordion-body {\n  padding: 1rem 1.25rem;\n  border-top: 1px solid #dee2e6;\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-site-section {\n  border-color: var(--bs-border-color);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-site-accordion .accordion-body {\n  border-top-color: var(--bs-border-color);\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-person-section .accordion-button,\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-person-btn {\n  background: var(--bs-body-bg) !important;\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-person-section .accordion-button:not(.collapsed),\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-person-btn:not(.collapsed) {\n  background: var(--bs-body-bg) !important;\n}\n\n.audit-schedule-official-trip-section-btn {\n  background: transparent !important;\n  box-shadow: none !important;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n}\n\n.audit-schedule-official-trip-section-title {\n  font-weight: 600;\n  font-size: 1rem;\n  flex: 1;\n  text-align: left;\n}\n\n.audit-schedule-official-trip-chevron {\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n  color: var(--bs-secondary);\n}\n\n.audit-schedule-official-trip-section-btn:not(.collapsed) .audit-schedule-official-trip-chevron {\n  transform: rotate(180deg);\n}\n\n.audit-schedule-official-trip-accordion .accordion-body {\n  padding: 1rem 1.5rem;\n  background: #f8f9fa;\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-accordion .accordion-body {\n  background: var(--bs-tertiary-bg);\n}\n\n.audit-schedule-official-trip-accommodation-card {\n  background: #fff;\n  border: 1px solid #dee2e6;\n  border-radius: 0.5rem;\n  padding: 1.25rem 1.5rem;\n  margin-bottom: 1.25rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  overflow: hidden; /* keep row negative margins from pushing checkboxes outside the card */\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-accommodation-card {\n  background: var(--bs-secondary-bg);\n  border-color: var(--bs-border-color);\n}\n\n.audit-schedule-official-trip-accommodation-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.25rem;\n  padding-bottom: 0;\n}\n\n.audit-schedule-official-trip-accommodation-heading {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n.audit-schedule-official-trip-accommodation-remove {\n  background: none;\n  border: none;\n  color: #dc3545;\n  padding: 0.25rem;\n  line-height: 0;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.audit-schedule-official-trip-accommodation-remove:hover {\n  color: #b02a37;\n  background: rgba(220, 53, 69, 0.1);\n}\n\n.audit-schedule-official-trip-fields {\n  margin-bottom: 0;\n  /* Neutralize Bootstrap row negative margins so content stays inside the card */\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.audit-schedule-official-trip-fields > [class*=\"col-\"] {\n  margin-bottom: 0;\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.audit-schedule-official-trip-fields > [class*=\"col-\"]:first-child {\n  padding-left: 0;\n}\n\n.audit-schedule-official-trip-fields > [class*=\"col-\"]:last-child {\n  padding-right: 0;\n}\n\n.audit-schedule-official-trip-toggle {\n  padding: 0.5rem 0;\n  margin-bottom: 0;\n}\n\n.audit-schedule-official-trip-accommodation-card .audit-schedule-official-trip-toggle {\n  margin-top: 0.25rem;\n}\n\n/* Keep the switch and label aligned; prevent checkbox from being pushed to edge */\n.audit-schedule-official-trip-accommodation-card .audit-schedule-official-trip-toggle.form-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  padding-left: 0;\n}\n\n.audit-schedule-official-trip-toggle .form-check-input {\n  cursor: pointer;\n  flex-shrink: 0;\n  margin-left: 0;\n  margin-top: 0.2rem;\n}\n\n/* Prevent Bootstrap form-switch from positioning the input at the container edge */\n.audit-schedule-official-trip-accommodation-card .form-check.form-switch .form-check-input {\n  position: relative;\n  left: 0;\n}\n\n.audit-schedule-official-trip-toggle .form-check-label {\n  cursor: pointer;\n  font-size: 0.875rem;\n}\n\n.audit-schedule-official-trip-contacts {\n  padding: 0.75rem 0;\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.audit-schedule-official-trip-contacts-title {\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin: 0 0 0.5rem 0;\n}\n\n.audit-schedule-official-trip-contact-row {\n  padding: 0.5rem 0;\n  border-bottom: 1px solid var(--bs-tertiary-bg);\n}\n\n.audit-schedule-official-trip-contact-row:last-of-type {\n  border-bottom: none;\n}\n\n.audit-schedule-official-trip-add-contact {\n  margin-top: 0.5rem;\n}\n\n.audit-schedule-official-trip-docs-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  margin: 0 0 0.5rem 0;\n}\n\n.audit-schedule-official-trip-accommodation-card .audit-schedule-official-trip-docs-label {\n  margin-top: 0.75rem;\n}\n\n.audit-schedule-official-trip-upload-zone {\n  padding: 1.5rem 1rem !important;\n  border: 2px dashed #dee2e6;\n  background: #f8f9fa;\n  border-radius: 0.5rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.audit-schedule-official-trip-upload-zone:hover {\n  border-color: #adb5bd;\n  background: #f1f3f5;\n}\n\n.audit-schedule-official-trip-upload-zone .small {\n  display: block;\n}\n\n.audit-schedule-official-trip-doc-list {\n  list-style: none;\n  padding: 0;\n  margin: 0 0 0.5rem 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.audit-schedule-official-trip-doc-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.35rem 0;\n  font-size: 0.875rem;\n}\n\n.audit-schedule-official-trip-doc-item span {\n  color: #0d6efd;\n}\n\n.audit-schedule-official-trip-document-list {\n  margin-top: 0.25rem;\n}\n\n.audit-schedule-official-trip-document-list .audit-schedule-document-card {\n  background: #fff;\n  border-color: #e9ecef;\n}\n\n[data-bs-theme=\"dark\"] .audit-schedule-official-trip-document-list .audit-schedule-document-card {\n  background: var(--bs-body-bg);\n  border-color: var(--bs-border-color);\n}\n\n.audit-schedule-official-trip-add-accommodation {\n  margin-top: 0.75rem;\n}\n\n/* Required field asterisk (Official Trip) */\n.audit-schedule-label-required::after,\n.audit-schedule-official-trip-accommodation-card .row.g-3 > .col-12:first-child .form-label::after {\n  content: ' *';\n  color: #dc3545;\n}\n\n.audit-schedule-official-trip-upload-icon {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.audit-schedule-official-trip-upload-text {\n  font-size: 0.875rem;\n  color: var(--bs-body-color);\n  margin: 0;\n}\n\n.audit-schedule-official-trip-upload-formats {\n  font-size: 0.8125rem;\n}\n\n/* Footer */\n.audit-schedule-footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: var(--bs-body-bg);\n  border-top: 1px solid var(--bs-border-color);\n  padding: 1rem 1.5rem;\n  z-index: 100;\n}\n\n@media (min-width: 768px) {\n  .audit-schedule-company-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
